import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal, setModal } from "../../features/modal/ModalSlice";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { IoCloseOutline } from "react-icons/io5";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";

const CreateCompanyPopUp = () => {
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({
    company_owner: "", // This will be the logged-in user ID
    company_website: "",
    company_name: "",
    domain: "",
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const { data } = useSelector((state) => state?.modal?.modal);

  const handleExtraLogin = async () => {
    try {
      const payload = {
        username: "admin",
        password: "November26$$",
      };
      const response = await apiClient.post(
        "https://voiceapi.sourcesoftsolutions.com/api/v1/auth/login",
        payload
      );
      // console.log(response, "response in login");

      if (response.statusCode === 200) {
        localStorage.setItem("token", response?.token);

        // toast.success("Welcome");
        // navigate(from, { replace: true });
      }
    } catch (err) {
      console.log("err: ", err);
      setErrors({ message: err });
    }
  };

  const handleCreateOrg = async (data) => {
    try {
      setLoading(true);
      await apiClient.post("https://voiceapi.sourcesoftsolutions.com/api/v1/organization", data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // Clear any previous messages

    // console.log(data);

    const companyData = {
      ...userDetails,
      company_owner: data?.company_owner, // Use the logged-in user ID here
    };

    try {
      await handleExtraLogin();

      await handleCreateOrg({
        name: userDetails?.company_name,
        domain: userDetails?.domain,
      });
      await apiClient.post("/companies", companyData);

      // Handle the API response
      toast("Company created successfully!");
      setLoading(false);
      dispatch(setModal({ type: "LOGIN" }));
      // navigate("/users");
    } catch (error) {
      setMessage("Failed to create company. Please try again.");
      setLoading(false);
    }
  };

  const handleClosePopup = () => {
    dispatch(closeModal());
  };

  return (
    <div>
      <Modal
        show={true}
        onHide={handleClosePopup}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="taskModal"
      >
        <Modal.Header className="px-4 py-3">
          <h4 className="m-0">Create Company</h4>
          <button className="btnClose ms-auto" onClick={handleClosePopup}>
            <IoCloseOutline />
          </button>
        </Modal.Header>
        <Modal.Body className="px-5">
          <form onSubmit={handleSubmit}>
            <Row>
              <Col xl={6}>
                <div className="inputData mt-5">
                  <input
                    type="text"
                    name="company_name"
                    id="company_name"
                    value={userDetails.company_name}
                    onChange={handleChange}
                    autoComplete="false"
                  />
                  <label htmlFor="company_name">Company Name</label>
                  {errors.company_name && (
                    <span style={{ color: "red" }}>{errors.company_name}</span>
                  )}
                  <div className="underline"></div>
                </div>
              </Col>

              <Col xl={6}>
                <div className="inputData mt-5">
                  <input
                    type="text"
                    name="company_website"
                    id="company_website"
                    value={userDetails.company_website}
                    onChange={handleChange}
                    autoComplete="false"
                  />
                  <label htmlFor="company_website">Company Website</label>
                  {errors.company_website && (
                    <span style={{ color: "red" }}>{errors.company_website}</span>
                  )}
                  <div className="underline"></div>
                </div>
              </Col>

              <Col xl={6}>
                <div className="inputData mt-5">
                  <input
                    type="text"
                    name="domain"
                    id="domain"
                    value={userDetails.domain}
                    onChange={handleChange}
                    autoComplete="false"
                  />
                  <label htmlFor="domain">Domain</label>
                  {errors.domain && <span style={{ color: "red" }}>{errors.domain}</span>}
                  <div className="underline"></div>
                </div>
              </Col>
            </Row>

            {message && <p>{message}</p>}

            <div className="text-center pt-5 pb-4">
              <Button className="btnSubmit w-50 py-2" type="submit" disabled={loading}>
                {loading ? (
                  <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateCompanyPopUp;
